import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import AdvancedSelect from "app/pages/.shared/form/AdvancedSelect";

const AlternativeDepartureCityList = ({
	cities = [],
	field = {},
	onMenuOpen,
	onMenuClose,
	openMenuOnFocus,
	onDepartureCityChange,
}) => {
	return (
		<div className="alternative-departure-city">
			<AdvancedSelect
				placeholder={
					<FormattedMessage id="search.engine.alternative.departure.cities.placeholder" />
				}
				noOptionsMessage={() => (
					<FormattedMessage id="search.engine.alternative.departure.cities.no.result" />
				)}
				value={cities.find(({ code }) => {
					return code === field.value;
				})}
				openMenuOnFocus={openMenuOnFocus}
				getOptionLabel={({ label }) => label}
				getOptionValue={({ code }) => code}
				blurInputOnSelect={true}
				onChange={event => {
					field.onChange(event);
					onDepartureCityChange(event);
				}}
				onMenuOpen={onMenuOpen}
				onMenuClose={onMenuClose}
				options={cities}
			/>
		</div>
	);
};

AlternativeDepartureCityList.propTypes = {
	cities: PropTypes.array,
	field: PropTypes.object,
	onDepartureCityChange: PropTypes.func,
	onMenuOpen: PropTypes.func,
	openMenuOnFocus: PropTypes.bool,
	onMenuClose: PropTypes.func,
};

export default AlternativeDepartureCityList;
